import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { APIConnectionUsersRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface APIConnectionUsersState {
    [key: string]: APIConnectionUsersRecord;
}

const initialState: APIConnectionUsersState = {};

const initialLoadAction = createAction<{ apiconnectionusers: {
    [apiConnectionUserId: string]: APIConnectionUsersRecord;
}; }>('InitialLoad');
const setApiConnectionUsersAction = createAction<APIConnectionUsersRecord[]>('SET_API_CONNECTION_USERS');
const apiConnectionUserRecordAction = createAction<APIConnectionUsersRecord>(CoreMsgTypes.APIConnectionUsersRecord);

const apiConnectionUsersSlice = createSlice({
    name: 'apiConnectionUsers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => action.payload.apiconnectionusers)
            .addCase(setApiConnectionUsersAction, (state, action) => {
                const mappedApiConnectionUsers = {};
                action.payload.forEach((apiConnectionUser) => {
                    mappedApiConnectionUsers[apiConnectionUser.APIConnectionUserId] = apiConnectionUser;
                });

                return {
                    ...state,
                    ...mappedApiConnectionUsers
                };
            })
            .addCase(apiConnectionUserRecordAction, (state, action) => {
                state[action.payload.APIConnectionUserId] = action.payload;
            })
            .addDefaultCase((state) => state);
    }
});

export default apiConnectionUsersSlice.reducer;